<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="search">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          v-hp="'add'"
          @click="showAddOrModifyView(null)"
          >新增</el-button
        >
      </div>
    </customize-page>

    <el-dialog
      :title="(formData.id === 0 ? '新增' : '修改') + '快递'"
      width="450px"
      :visible.sync="showFormDialog"
    >
      <el-form
        style="width: 400px; margin: 0 auto"
        ref="form"
        :model="formData"
        label-width="80px"
      >
        <el-form-item label="快递名">
          <el-input v-model="formData.name"></el-input>
        </el-form-item>
        <el-form-item label="快递编码">
          <el-input v-model="formData.code"></el-input>
        </el-form-item>
        <el-form-item label="快递类型">
          <el-select v-model="formData.type" placeholder="请选择快递类型">
            <el-option label="国际" value="0"></el-option>
            <el-option label="国内" value="-1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveCarrier()">保存</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import CustomizePage from "@/components/customize-page";
import Page from "@/mixin/Page";

import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    this.defaultFormData = JSON.stringify(this.formData);
  },
  mounted() {
    this.fetch();
  },
  data() {
    return {
      loading: false,
      dataList: [],
      showFormDialog: false,
      defaultFormData: "",
      formData: {
        id: 0,
        name: "",
        code: "",
        type: "",
      },
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "快递名",
          width: 200,
          fixed: "left",
          key: "name",
          align: "center",
          render: (h, param) => {
            let jsonConfig = param.row.jsonConfig;
            let name = param.row.name;
            return (
              <a
                style="color:blue"
                onClick={this.showConfig.bind(this, jsonConfig)}
              >
                {name}
              </a>
            );
          },
        },
        {
          title: "快递编码",
          width: 200,
          fixed: "left",
          key: "code",
          align: "center",
        },
        {
          title: "类型",
          width: 200,
          fixed: "left",
          key: "typeStr",
          align: "center",
        },
        {
          title: "快递接口",
          "min-width": 200,
          fixed: "left",
          key: "interfaceUrl",
          align: "center",
        },
        {
          title: "创建时间",
          width: 180,
          key: "gmtCreate",
          align: "center",
        },
        {
          title: "操作",
          width: 180,
          align: "center",
          render: (h, param) => {
            let data = param.row;
            let operation = [];
            if (this.$hasPermission(this.$route, "edit")) {
              operation.push(
                <a
                  style="color:blue"
                  onClick={this.showAddOrModifyView.bind(this, data)}
                >
                  编缉
                </a>
              );
            }
            return operation;
          },
        },
      ],
      filterObj: {
        carrierName: "",
        type: 127,
      },
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {},
  methods: {
    ...mapActions({
      list: "cs/carrierList",
      addOrModify: "cs/addOrModifyCarrier",
    }),
    showConfig(config) {
      this.$alert(
        '<p style="white-space:pre;">' +
          JSON.stringify(JSON.parse(config), null, "\t") +
          "</p>",
        "快递配置",
        {
          confirmButtonText: "确定",
          dangerouslyUseHTMLString: true,
          callback: (action) => {},
        }
      );
    },
    // 更新品牌列表
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      const sortObj = this.sortObj;
      let searchCondition = {
        ...sortObj,
        request: JSON.stringify({
          ...filterParams,
          page: {
            pageIndex: this.pagination.currentPage,
            pageSize: this.pagination.pageSize,
          },
        }),
      };

      this.list(searchCondition)
        .then((res) => {
          this.loading = false;
          this.dataList = res.items || [];
          const pageInfo = res.page || { totalCount: 0 };
          this.pagination.totalCount = pageInfo.totalCount;
        })
        .catch((error) => {
          this.loading = false;
          this.$message.error("异常");
        });
    },
    showAddOrModifyView(data) {
      if (data != null) {
        this.formData.id = data.id;
        this.formData.name = data.name;
        this.formData.code = data.code;
        this.formData.type = data.typeStr === "国际" ? "0" : "-1";
      } else {
        this.formData = JSON.parse(this.defaultFormData);
      }
      this.showFormDialog = !this.showFormDialog;
    },
    saveCarrier() {
      this.addOrModify(this.formData).then((res) => {
        if (res.value) {
          this.showFormDialog = !this.showFormDialog;
          this.fetch();
          this.$message.success("保存成功");
        } else {
          this.$message.error("保存失败");
        }
      });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      return [
        {
          data: [
            {
              label: "快递名",
              model: "carrierName",
              type: type.INPUT,
            },
            {
              label: "类型",
              model: "type",
              type: type.SELECT,
              props: {
                data: [
                  {
                    value: 127,
                    label: "全部",
                  },
                  {
                    value: -1,
                    label: "国内",
                  },
                  {
                    value: 0,
                    label: "国际",
                  },
                ],
              },
            },
          ],
        },
      ];
    },
  },
};
</script>
